import { renderRoutes } from 'react-router-config';

import routes from './routes';

const CardsMasterRoute = () => renderRoutes(routes);

export default CardsMasterRoute;
